import { idleUtils } from '@mm/utils';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getEnv } from '../actions/networkActions';

const TEN_MINUTES = 600000;

export const useSetupEnvFetch = () => {
  const dispatch = useDispatch();
  const loadEnv = async () => {
    try {
      await dispatch(getEnv());
    } catch (err) {
      // Ignore network errors when fetching data
      if (!(err instanceof TypeError)) {
        throw err;
      }
    }
  };

  useEffect(() => {
    loadEnv();

    setInterval(() => {
      if (!idleUtils.isIdle()) {
        loadEnv();
      }
    }, TEN_MINUTES);
  }, []);
};
